<app-column-chart-multiple [height]="height" [maxValue]="maxValue" [data]="compareData" [stack]="true"> </app-column-chart-multiple>
